import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';

const AllUsers = () => {
  const { isSidebarOpen } = useSidebar();

  const [searchQuery, setSearchQuery] = useState('');
const [users, setUsers] = useState([]);

  const [filteredUsers, setFilteredUsers] = useState(users);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

          const BASE_URL = process.env.REACT_APP_API_BASE_URL;


  useEffect(() => {
    const filtered = users.filter((user) =>
      Object.values(user).some((value) =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
    setFilteredUsers(filtered);
    setCurrentPage(1);
  }, [searchQuery, users]);

  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);
  const currentData = filteredUsers.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleSearch = (e) => setSearchQuery(e.target.value);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleDelete = (email) => {
    const updatedUsers = users.filter(user => user.email !== email);
    setUsers(updatedUsers);
  };

useEffect(() => {
  const fetchUsers = async () => {
    try {
      const response = await fetch(`${BASE_URL}/api/myprofile/all`); // You’ll define this route
      const data = await response.json();

const formattedUsers = data.users.map(profile => ({
        name: `${profile.firstName} ${profile.lastName}`,
        gender: profile.gender,
        dob: profile.dob,
        nationality: profile.nationality,
        phone: profile.phone,
        email: profile.email,
        passportNumber: profile.passport,
        passportExpiry: profile.expiry,
        passportIssueCountry: profile.issuingCountry,
        panNumber: profile.pan,
      }));

      setUsers(formattedUsers);
    } catch (err) {
      console.error("Error fetching users:", err);
    }
  };

  fetchUsers();
}, []);




  return (
    <>
      <Header />
      <Sidebar />
      <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
        <h1 className="dashboard-title">All Users</h1>

        <div className="filter-search">
          <div className="filter-search-input">
            <input
              type="search"
              placeholder="Search..."
              value={searchQuery}
              onChange={handleSearch}
            />
            <i className="fa fa-search"></i>
          </div>
        </div>

        <div className="customer-table">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Gender</th>
                <th>DOB</th>
                <th>Nationality</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Passport No.</th>
                <th>Expiry</th>
                <th>Issue Country</th>
                <th>PAN</th>
              </tr>
            </thead>
            <tbody>
              {currentData.length > 0 ? (
                currentData.map((user, index) => (
                  <tr key={index}>
                    <td>{user.name}</td>
                    <td>{user.gender}</td>
                    <td>{user.dob}</td>
                    <td>{user.nationality}</td>
                    <td>{user.phone}</td>
                    <td>{user.email}</td>
                    <td>{user.passportNumber}</td>
                    <td>{user.passportExpiry}</td>
                    <td>{user.passportIssueCountry}</td>
                    <td>{user.panNumber}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" style={{ textAlign: 'center' }}>No users found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            <i className="fa-solid fa-chevron-left"></i>
          </button>

          <button className="active">{currentPage}</button>

          {currentPage < totalPages && (
            <button onClick={() => paginate(currentPage + 1)}>
              {currentPage + 1}
            </button>
          )}

          {currentPage + 1 < totalPages && <span className="dots">...</span>}

          {currentPage !== totalPages && (
            <button onClick={() => paginate(totalPages)}>
              {totalPages}
            </button>
          )}

          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
            <i className="fa-solid fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </>
  );
};

export default AllUsers;
